module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray-e2df30f9749bce006f038834b9168069.png";